import React, { useState, useEffect } from "react";
import { Container } from "./styled";
import firebase from "../../lib/fire";
import { useHistory } from "react-router";
import "../../App.css";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { SearchInput } from "../../components";

const Navbar = () => {
  const history = useHistory();
  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
  const userLocal = secureLocalStorage.getItem("userLocal");
  const sessionUser = sessionStorage.getItem("user");

  const handleLogout = () => {
    firebase.auth().signOut();
    sessionStorage.removeItem("user");
    sessionStorage.setItem("userAuth", false);
    history.push("/");
    secureLocalStorage.removeItem("userLocal");
  };

  return (
    <Container>
      <div className="logo-container no-print">
        <Link
          to={
            sessionUser !== undefined && sessionUser !== null
              ? "/app/main"
              : "/"
          }
        >
          <img
            className="navbarLogo"
            src="/assets/Logo.png"
            alt="deportactico logo"
          />
          <h1>Deportactico</h1>
        </Link>
      </div>
      <SearchInput />
      <img
        className="hamburguer-menu-icon no-print"
        alt="menu icon"
        src="/assets/Menu-icon-b.png"
        onClick={(e) => setIsHamburgerMenuOpen(!isHamburgerMenuOpen)}
      />
      <div
        className={`navigation-container ${
          isHamburgerMenuOpen ? "active" : null
        }`}
      >
        <ul>
          <li className="servicis">
            Herramientas
            <ul id="servicis-submenu" className="servicis-submenu">
              <li>
                <Link
                  to="/app/main"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Animaciones
                </Link>
              </li>
              <li>
                <Link
                  to="/estadisticas"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Estadísticas
                </Link>
              </li>
              <li>
                <Link
                  to="/app/analytics-dashboard"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Analíticas
                </Link>
              </li>
              <li>
                <Link
                  to="/app/games"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Partidos
                </Link>
              </li>
              <li>
                <Link
                  to="/app/lineups"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Alineaciones
                </Link>
              </li>
              <li>
                <Link
                  to="/app/scatter-plots"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Diagrama de dispersión
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="/blog"
              onClick={() => {
                window.scroll(0, 0);
              }}
            >
              Blog
            </Link>
          </li>
          <li className="servicis">
            Nosotros
            <ul id="servicis-submenu" className="servicis-submenu">
              <li>
                <Link
                  to="/blog/about"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Nosotros
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Contacto
                </Link>
              </li>
              <li>
                <Link
                  to="/app/suscriptions"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  Suscripciones
                </Link>
              </li>
            </ul>
          </li>
          {sessionUser !== undefined && sessionUser !== null ? (
            <li className="account-menu servicis">
              {userLocal?.name}
              <ul id="servicis-submenu" className="servicis-submenu">
                <li>
                  <Link
                    to="/app/profile"
                    onClick={() => {
                      window.scroll(0, 0);
                    }}
                  >
                    Perfil
                  </Link>
                </li>
                <li>
                  <button
                    href="#"
                    onClick={handleLogout}
                    id="logoutButton"
                    className="btn-primary ghost"
                  >
                    SALIR
                  </button>
                </li>
              </ul>
            </li>
          ) : (
            <Link to="/app/login" className="btn-primary">
              INGRESAR
            </Link>
          )}
        </ul>
      </div>
    </Container>
  );
};
export default Navbar;
